import React from 'react'
import { XBlock, XMasonry } from 'react-xmasonry/dist'
import { IAccount } from 'shopify-payment-core'

import { AccountBasicInfo } from '../bricks/AccountBasicInfo'
import { AccountBillingAdmin } from '../bricks/AccountBillingAdmin'
import { AccountBlocking } from '../bricks/AccountBlocking'
import { AccountClientInfo } from '../bricks/AccountClientInfo'
import { AccountGateway } from '../bricks/AccountGateway'
import { PaymentGatewayConfig } from '../bricks/PaymentGatewayConfig'
import { GoPayCredentials } from '../segments/gopay/GoPayCredentials'
import { GoPayInstruments } from '../segments/gopay/GoPayInstruments'

interface IProps {
  account: IAccount
}

export const AccountBrickLayout: React.FC<IProps> = ({ account }) => {
  return (
    <XMasonry center={false} targetBlockWidth={200}>
      <XBlock width={2}>
        <AccountBasicInfo account={account} />
        <AccountClientInfo account={account} />
        <AccountBlocking account={account} />
      </XBlock>
      <XBlock width={3}>
        <AccountBillingAdmin account={account} />
      </XBlock>
      <XBlock width={2}>
        <AccountGateway account={account} />
      </XBlock>
      <XBlock width={2}>
        <GoPayCredentials accountId={account.id} />
        <GoPayCredentials accountId={account.id} useTestMode={true} />
      </XBlock>
      <XBlock width={2}>
        <PaymentGatewayConfig account={account} />
      </XBlock>
      <XBlock width={2}>
        <GoPayInstruments account={account} />
      </XBlock>
    </XMasonry>
  )
}
